module.exports = __webpack_public_path__ + "img/雨.02b6eae7.png";